import React from "react";
import {
  MdAssignment,
  MdFileUpload,
  MdCreate,
  MdAssignmentTurnedIn,
  MdLink
} from "react-icons/md";

import OperationCar from "../pages/NewOperation/components/FormSteps/OperationCar";
import OperationAreas from "../pages/NewOperation/components/FormSteps/OperationAreas";
import OperationResults from "../pages/NewOperation/components/FormSteps/OperationResults";
import OperationInformations, {
  saveInformations
} from "../pages/NewOperation/components/FormSteps/OperationInformations";
import OperationCarLinking from "~/pages/NewOperation/components/FormSteps/OperationCarLinking";

const STEPS = [
  {
    value: "dados-da-operacao",
    barLabel: f => f("dados-da-operacao"),
    saveHandler: saveInformations,
    icon: MdAssignment,
    dependsOn: [],
    render: props => <OperationInformations {...props} />,
    allowedOnStartTypes: ["car", "gleba"]
  },
  {
    value: "cadastro-car",
    barLabel: () => "CAR",
    icon: MdFileUpload,
    dependsOn: ["dados-da-operacao"],
    render: props => <OperationCar {...props} />,
    allowedOnStartTypes: ["car"]
  },
  {
    value: "glebas",
    barLabel: f => f("glebas"),
    icon: MdCreate,
    dependsOn: [
      "dados-da-operacao"
      // "cadastro-car"
    ],
    render: props => <OperationAreas {...props} />,
    allowedOnStartTypes: ["car", "gleba"]
  },
  {
    value: "vinculacao-car",
    barLabel: f => f("vinculacao-car"),
    icon: MdLink,
    dependsOn: [
      "dados-da-operacao"
      // "cadastro-car"
    ],
    render: props => <OperationCarLinking {...props} />,
    allowedOnStartTypes: ["gleba"]
  },
  {
    value: "resultados",
    icon: MdAssignmentTurnedIn,
    barLabel: f => f("resultados"),
    dependsOn: [
      "dados-da-operacao"
      // "cadastro-car", "glebas"
    ],
    render: props => <OperationResults {...props} />,
    allowedOnStartTypes: ["car", "gleba"]
  }
];

export default STEPS;
